import { ACTIVE_CURRENCY_CODE_UPDATED, CUSTOMER_CURRENCY_CODE_RECEIVED, DEFAULT_CURRENCY_CODE_RECEIVED } from './constants/ActionTypes';
export const setCustomerCurrencyCode = payload => {
  return {
    type: CUSTOMER_CURRENCY_CODE_RECEIVED,
    payload
  };
};
export const setActiveCustomerCurrencyCode = payload => {
  return {
    type: ACTIVE_CURRENCY_CODE_UPDATED,
    payload
  };
};
export const setDefaultCurrencyCode = payload => {
  return {
    type: DEFAULT_CURRENCY_CODE_RECEIVED,
    payload
  };
};